import React from 'react';
import _ from 'underscore';

import * as OrganizationActions from 'actions/OrganizationActions';
import {NavStoreProject} from 'constants/SourceConstants';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {Organization} from './OrganizationConstants';
import ProjectsTable from './ProjectsTable';

interface Props {
  isCurrentUserMember: boolean;
  organization: Organization;
  organizationProjects?: Array<NavStoreProject>;
}

class OrganizationProjectsTab extends React.Component<Props> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleUpdateProjectSettings = () => {
    // Refetch the projects to reflect any changes.
    OrganizationActions.fetchProjects(this.props.organization.id);
  };

  render(): JSX.Element {
    if (this.props.organizationProjects == null) {
      return <CenteredHorizontalThrobber />;
    }

    if (this.props.organizationProjects.length === 0) {
      return this.props.isCurrentUserMember ? (
        <div>This organization has no projects yet.</div>
      ) : (
        <div>This organization does not have any projects that you can view.</div>
      );
    }

    // Display projects that are owned by the organization first
    // NOTE: if we end up doing this on other ProjectsTable uses, we can define a self_owner sort key and
    // use that sort key instead of sorting projects outside the ProjectsTable
    let [orgOwnedProjects, orgSharedProjects] = _.partition(
      this.props.organizationProjects,
      (project) => project.s_owner.id === this.props.organization.id
    );
    orgOwnedProjects = _.sortBy(orgOwnedProjects, (project) => project.name.toLowerCase());
    orgSharedProjects = _.sortBy(orgSharedProjects, (project) => project.name.toLowerCase());
    const orgProjects = orgOwnedProjects.concat(orgSharedProjects);

    return (
      <ProjectsTable
        onUpdateProjectSettings={this._handleUpdateProjectSettings}
        overrideInitialSort={true}
        projects={orgProjects}
        shouldShowOwnerColumn={!this.props.organization.disablePersonalOwnables}
      />
    );
  }
}

export default OrganizationProjectsTab;
